import { FC } from 'react';

import './chatroom.scss';

type TProps = {
  chatroomId: string;
  title?: string;
};

/**
 * Example usage: <Chatroom chatroomId="r0CRjf4uS" title="test" />
 */
const Chatroom: FC<TProps> = ({ chatroomId, title }) => {
  if (!chatroomId) return null;
  return (
    <div className="chat-wrapper">
      {title && (
        <div className="chat-header">
          <span>{title}</span>
        </div>
      )}

      <iframe allowFullScreen src={`https://deadsimplechat.com/${chatroomId}`} title="Video player chat" />
    </div>
  );
};

export default Chatroom;
